import React, { useEffect, useState } from "react";
import HeaderImg from "../components/HeaderImg";
import {
  ErrorMessage,
  Input,
  Label,
  Textarea,
} from "../components/styledComponent/formInputs";
import { toast } from "react-toastify";
import { sendMessage } from "../api/usersApi";
import Loading from "../components/Loading";

const ContactUs = ({ contactPage }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [inputError, setInputError] = useState({});

  const validate = () => {
    let nameError = "";
    let messageError = "";
    let emailError = "";
    let phoneError = "";

    if (name.length < 2) {
      nameError = "name is required, minimum 2 characters";
    }
    if (message.length < 2) {
      messageError = "message is required, minimum 2 characters";
    }
    if (!email) {
      emailError = "email is required";
    }
    if (email && !email.includes("@")) {
      emailError = "email must be valid";
    }
    if (!phone) {
      phoneError = "phone is required";
    }
    if (phone && phone.length < 7) {
      phoneError = "phone number must be valid";
    }

    if (nameError || messageError || emailError || phoneError) {
      setInputError((curr) => {
        return {
          ...curr,
          name: nameError,
          message: messageError,
          email: emailError,
          phone: phoneError,
        };
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    const checkValidate = validate();

    if (checkValidate) {
      setInputError({});
      setLoading(true);
      try {
        const data = {
          name,
          message,
          phone,
          email,
        };
        await sendMessage(data);

        setLoading(false);
        setName("");
        setEmail("");
        setMessage("");
        setPhone("");
        toast.success("Message sent successfully");
      } catch (err) {
        setLoading(false);
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          err.toString();
        toast.error(message);
      }
    }
  };

  return (
    <div className="contactUs">
      <div
        className={
          contactPage ? "contactUs__mainCon alt" : "contactUs__mainCon"
        }
      >
        <div className="contactUs__main">
          <div className="contactUs__left">
            {!contactPage ? (
              <>
                <h2 className="featured__header__main"> Contact Us</h2>
                <h3>Let's get in touch.</h3>
              </>
            ) : (
              <h2
                className="featured__header__main"
                style={{ marginBottom: 30 }}
              >
                {" "}
                Let's get in touch.
              </h2>
            )}
            <p>
              <i className="bx bx-location-alt-2"></i> <b>Address</b>
            </p>
            <p>NO 22, 14 Road, Corner Shop, Gwarinpa Estate, Abuja, Nigeria.</p>
            <br />

            <p>
              <b>
                <i className="bx bx-envelope"></i> Email
              </b>
              <br />
            </p>
            <p>
              <a href="mailto:chaolcarington1@gmail.com">
                chaolcarington1@gmail.com
              </a>
            </p>
            <br />

            <p>
              <b>
                {" "}
                <i className="bx bx-phone"></i> Telephone
              </b>
            </p>
            <p>
              <a href="tel:+2347041410503">+234 704 1410 503</a>
            </p>
            <p>
              <a href="tel:+2349052070322">+234 905 2070 322</a>
            </p>
            <p>
              <a href="tel:+2348133374900">+234 813 3374 900</a>
            </p>
          </div>
          <div
            className={
              contactPage ? "contactUs__right alt" : "contactUs__right"
            }
          >
            <div className="">
              <Label htmlFor="name">
                {" "}
                Name <span>*</span>
              </Label>
              <Input
                id="name"
                value={name}
                type="text"
                error={inputError.name ? true : false}
                onChange={(e) => setName(e.target.value)}
              />
              <ErrorMessage show={true}>{inputError?.name}</ErrorMessage>
            </div>
            <div className="">
              <Label htmlFor="email">
                {" "}
                Email <span>*</span>
              </Label>
              <Input
                id="email"
                type="text"
                value={email}
                error={inputError.email ? true : false}
                onChange={(e) => setEmail(e.target.value)}
              />
              <ErrorMessage show={true}>{inputError?.email}</ErrorMessage>
            </div>
            <div className="">
              <Label htmlFor="phone">
                {" "}
                Phone Number <span>*</span>
              </Label>
              <Input
                id="phone"
                type="number"
                value={phone}
                error={inputError.phone ? true : false}
                onChange={(e) => setPhone(e.target.value)}
              />
              <ErrorMessage show={true}>{inputError?.phone}</ErrorMessage>
            </div>
            <div className="">
              <Label htmlFor="message">
                {" "}
                Message <span>*</span>
              </Label>
              <Textarea
                name="message"
                id="message"
                rows="7"
                value={message}
                error={inputError.message ? true : false}
                onChange={(e) => setMessage(e.target.value)}
              ></Textarea>
              <ErrorMessage show={true}>{inputError?.message}</ErrorMessage>
            </div>

            <button className="btn" onClick={handleSubmit}>
              {loading ? <Loading button={true} /> : "Send"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
